<template>
  <div class="profile-view-container">
    <div class="ambient-glow ambient-glow--indigo"></div>
    <div class="ambient-glow ambient-glow--rose"></div>

    <v-container class="profile-content-wrap">
      <!-- Profile Content -->
      <div v-if="user" class="profile-content">
        <user-profile
          :user="user"
          :show-actions="true"
          @edit="editProfile"
          @logout="logout"
        />
      </div>

      <!-- Loading State -->
      <v-card v-else class="glass-card pa-12 text-center my-8">
        <v-progress-circular
          indeterminate
          color="primary"
          size="64"
          width="4"
          class="mb-4"
        />
        <p class="text-body-1 text-medium-emphasis mb-0">Loading profile data...</p>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import UserProfile from '@/components/UserProfile.vue'

export default {
  name: 'Profile',
  components: {
    UserProfile,
  },
  setup() {
    const store = useStore()
    const router = useRouter()

    const user = computed(() => store.getters['auth/user'])

    onMounted(async () => {
      if (!user.value) {
        try {
          await store.dispatch('auth/fetchUser')
        } catch (error) {
          console.error('Failed to fetch user profile:', error)
          router.push('/')
        }
      }
    })

    const editProfile = () => {
      console.log('Edit profile')
    }

    const logout = () => {
      store.dispatch('auth/logout')
      router.push('/')
    }

    return {
      user,
      editProfile,
      logout,
    }
  },
}
</script>

<style scoped>
.profile-view-container {
  min-height: calc(100vh - 72px);
  position: relative;
  overflow: hidden;
  padding: 24px 0 48px;
}

.profile-content-wrap {
  position: relative;
  z-index: 2;
  max-width: 1000px;
}

.ambient-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(120px);
  pointer-events: none;
  opacity: 0.2;
}

.ambient-glow--indigo {
  width: 400px;
  height: 400px;
  top: 5%;
  left: 10%;
  background: #6366f1;
}

.ambient-glow--rose {
  width: 350px;
  height: 350px;
  bottom: 10%;
  right: 10%;
  background: #f43f5e;
}
</style>

